import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
	name: 'auUserInitialsPipe',
})
export class AuUserInitialsPipe implements PipeTransform {
	transform(value: { [key: string]: any } | string): string {
		if (typeof value === 'object') {
			const initialsKeys = [];
			if (value?.firstName) {
				initialsKeys.push(
					...(value?.firstName?.includes(' ') && !value?.lastName
						? value.firstName.split(' ').map(part => part[0])
						: value.firstName[0])
				);
				if (!value?.lastName && !value?.firstName?.includes(' ')) {
					initialsKeys.push(value?.firstName[1]);
				}
			}
			initialsKeys.push(
				value?.lastName,
				value?.fullName,
				value?.name,
				value?.displayName,
				value?.email
			);

			const initials = initialsKeys
				.map(name => (name ? name.trim()[0] : ''))
				.filter(Boolean)
				.slice(0, 2)
				.join('')
				.toUpperCase();
			return initials.length ? initials : 'N/A';
		} else if (typeof value === 'string' && !!value.length) {
			if (value.includes(' ')) {
				const name = value.split(' ');
				return name[0][0] + name[name.length - 1][0];
			}
			return value.slice(0, 2);
		} else {
			return 'N/A';
		}
	}
}
